import React, { Component } from 'react';
import firebase from '../firebase.js';


export default class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menus: [],
            hotel: null,
            currentUser: null
        }
    }
    componentDidMount() {
        firebase.auth().onAuthStateChanged((user) => {
            if(user){
                this.setState({
                    currentUser: user
                });
                firebase.database().ref('/Hotels/accounts/'+user.uid).once('value').then((snapshot) => {
                    if(snapshot.val()) {
                        let menu = snapshot.val().menu;
                        this.setState({
                            hotel: snapshot.val(),
                            menus: menu
                        });
                        console.log('menu: ', menu);
                    }else {
                        this.props.history.push('/');
                    }

                });
            } else {
                this.props.history.push('/');
            }
        });
    }
    render() {
        return (
            <div></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Menu.js